<div class="pill typography-text-small-regular-primary"
[style.text-transform]="themeService.buttonConfig().textTransform">
    {{ label }}
  </div>